export const constants = {
  MENU: {
    DASHBOARD: "Dashboard",
    CATEGORY: "Category",
    FOOD: "Food",
    ORDER: "Order",
    STAFF: "Staff",
    TABLE: "Table",
    REPORTS: ["Reports", "Sales", "Item Wise Sales", "Refunds", "Customers", "Orders", "Coupons"],
    INVENTORY: ["Ingredients", "Purchase Item", "Supplier", "Report", "Recipe", "Wastage", "Final Report"],
  },

  GENERAL_MENU: {
    DASHBOARD: "Dashboard",
    FOOD: "Food",
    ORDER: "Order",
  },
  SUPER_MENU: {
    RESTAURANT: "Restaurants",
    USER: "Users",
    GROUP: "Groups",
    // ORDERS: 'Orders'
  },
  SUPER_ADMIN_SUBMENU: {
    RESTAURANT_CREATE: "Restaurants-create",
    RESTAURANT_DETAILS: "",
  },
  IGNORE_MENU: {
    PROFILE: "profile",
    CHANGE_PASSWORD: "change-password",
  },
  ICON: {
    DASHBOARD: "dashboard.svg",
    CATEGORY: "category.svg",
    FOOD: "food.svg",
    ORDER: "order.svg",
    STAFF: "staff.svg",
  },
  FOOD: {
    VIEW: "VIEW",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
  },
  STAFF: {
    CHANGE: "CHANGE",
    VIEW: "VIEW",
    EDIT: "EDIT",
    ON: "ON",
    OFF: "OFF",
    DELETE: "DELETE",
  },
  ORDER: {
    DECLINE: "DECLINE",
    ACCEPT: "ACCEPT",
    PAID: "PAID",
    PROCESSING: "PROCESSING",
    WAITING: "WAITING",
    PREPARED: "PREPARED",
    SERVED: "SERVED",
    VIEW: "VIEW",
    DISCOUNT: "DISCOUNT",
    EDIT: "EDIT",
    INVOICE: "INVOICE",
    REFUND: "REFUND",
  },
  GROUP: {
    VIEW: "VIEW",
    QR: "QR",
    DELETE: "DELETE",
  },
  USER_TYPE: {
    ADMIN: "Admin",
    STAFF: "Staff",
    CHEF: "Chef",
  },
  SORT_TYPE: {
    A_TO_Z: "a-to-z",
    Z_TO_A: "z-to-a",
    NEWEST: "newest",
    OLDEST: "oldest",
  },
  USER_KEY: "USER_PAYLOAD",
  USER_DEFAULT_BRANCH: "USER_DEFAULT_BRANCH",
  USER_DEFAULT_BRANCH_SLUG: "USER_DEFAULT_BRANCH_SLUG",
  USER_DEFAULT_BRANCH_NAME: "USER_DEFAULT_BRANCH_NAME",
  USER_DEFAULT_ROLE: "USER_DEFAULT_ROLE",
  USER_LOGGED_IN: "USER_LOGGED_IN",
  NOTIFICATION: {
    INFO: "info",
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
  },

  DISCOUNT_TYPE: {
    AMOUNT: "Amount",
    PERCENTAGE: "Percentage",
  },
  PAYMENT_STATUS: {
    PAID: "Paid",
    UNPAID: "Unpaid",
    PAY_LATER: "Pay Later",
    // DUE: "Due",
    REFUND: "Refund due",
    REFUNDED: "Refunded",
    DISCOUNT: "Discount",
  },
  ORDER_STATUS: {
    PENDING: "Pending",
    ONGOING: "Ongoing",
    // PREPARED: "Prepared",
    // DELIVERED: "Delivered",
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
  },
  CUSTOMER_STATUS: {
    NEW: "New",
    RETURNING: "Returning",
  },
};

export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  MANAGER: "Manager",
  STAFF: "Staff",
  CHEF: "Chef",
};

export const POSITIONS = {
  ADMIN: "Admin",
  MANAGER: "Manager",
  STAFF: "Staff",
  CHEF: "Chef",
  WAITER: "Waiter",
  BARTENDER: "Bartender",
};

export const GENDER = {
  MALE: "Male",
  FEMALE: "Female",
};

export const FOOD_MENU = {
  SINGLE: "Single Food Menu",
  COMBO: "Combo Food Menu",
};

export const CONTACT_MEDIUM = {
  CALL: "Call",
  WHATSAPP: "Whatsapp",
  MESSENGER: "Messenger",
};

export const CONTACT_URL = {
  CALL_URL: "tel:+8801601497699",
  WHATSAPP_URL: "https://api.whatsapp.com/send?phone=8801601497699",
  MESSENGER_URL: "https://m.me/TableTapBD",
};

export const paymentStatusList = [
  {
    key: 1,
    value: 1,
    label: constants.PAYMENT_STATUS.PAID,
  },
  {
    key: 2,
    value: 0,
    label: constants.PAYMENT_STATUS.UNPAID,
  },
  {
    key: 3,
    value: 2,
    label: constants.PAYMENT_STATUS.PAY_LATER,
  },
  // {
  //   key: 4,
  //   value: 3,
  //   label: constants.PAYMENT_STATUS.DUE,
  // },
  {
    key: 5,
    value: 4,
    label: constants.PAYMENT_STATUS.REFUND,
  },
  {
    key: 7,
    value: 7,
    label: constants.PAYMENT_STATUS.REFUNDED,
  },
  {
    key: 6,
    value: 5,
    label: constants.PAYMENT_STATUS.DISCOUNT,
  },
];

export const orderStatusList = [
  {
    value: 1,
    label: constants.ORDER_STATUS.PENDING,
  },
  {
    value: 2,
    label: constants.ORDER_STATUS.ONGOING,
  },
  // {
  //   value: 3,
  //   label: constants.ORDER_STATUS.PREPARED,
  // },
  // {
  //   value: 4,
  //   label: constants.ORDER_STATUS.DELIVERED,
  // },
  {
    value: 6,
    label: constants.ORDER_STATUS.COMPLETED,
  },
  {
    value: 5,
    label: constants.ORDER_STATUS.CANCELLED,
  },
];

export const CustomerStatusList = [
  {
    value: 1,
    label: constants.CUSTOMER_STATUS.NEW,
  },
  {
    value: 2,
    label: constants.CUSTOMER_STATUS.RETURNING,
  },
];

export const ORDER_REPORT_STATUS = [
  {
    value: "REFUNDED",
    label: "Refunded",
  },
  {
    value: "PENDING",
    label: "Pending",
  },
];
export const openDays = ["Sat", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri"];

export const paymentOptions = ["ONLINE", "POS", "CASH"];

export const orderDefaultValues = {
  orderId: "",
  orderNumber: "",
  orderType: "Dine-in",
  countryCode: "",
  phone: "",
  tableNumber: "",
  foods: [],
  payAfterEat: false,
  cookingTime: "30",
  comment: "",
  editingComment: "",
  totalPrice: "",
  totalPriceBeforeDiscount: "",
  vat: "",
  serviceCharge: "",
  paymentStatus: 0,
};

export const orderTypeOptions = [
  {
    value: "Dine-in",
    label: "Dine-in",
  },
  {
    value: "Takeout",
    label: "Takeout",
  },
];

export const orderUpsertDefaultFoods = [
  {
    id: `${Date.now()}`,
    categoryId: "",
    foodId: "",
    optionId: "",
    quantity: 1,
    addOns: [],
    comment: "",
  },
];

export const revenueReportBoardMetrics = {
  salesReport: ["Todays Revenue", "This Weeks", "This Month", "This Year"],
  itemWiseSalesReport: [],
  refundsReport: ["Cancel Order", "Refund Order", "Refund Pending"],
  customers: ["New Customers", "Returning Customers"],
  orderReport: ["Todays Order", "This weeks", "This month", "This year"],
};

export const SALES_REPORT_PAYMENT_TYPE = [
  {
    value: "ONLINE",
    label: "Online",
  },
  {
    value: "COUNTER",
    label: "Counter",
  },
];

export const ITEM_WISE_SALES_REPORT_SORTBY = [
  {
    value: "SOLD_COUNT_ASC",
    label: "Count Asc",
  },
  {
    value: "SOLD_COUNT_DESC",
    label: "Count Desc",
  },
  {
    value: "SOLD_PRICE_ASC",
    label: "Price Asc",
  },
  {
    value: "SOLD_PRICE_DESC",
    label: "Price Desc",
  },
  {
    value: "NAME_ASC",
    label: "Name Asc",
  },
  {
    value: "NAME_DESC",
    label: "Name Desc",
  },
];

export const CUSTOEMR_REPORT_STATUS = [
  {
    value: "NEW",
    label: "New",
  },
  {
    value: "RETURNING",
    label: "Returning",
  },
];

export const REPORT_ORDER_TYPE = [
  {
    value: "DINE_IN",
    label: "Dine In",
  },
  {
    value: "TAKEOUT",
    label: "Takeout",
  },
];

/** TableHeaderComponent sorting options */
export const sortingOptions1 = [
  {
    key: "NEWEST",
    label: "Newest",
  },
  {
    key: "OLDEST",
    label: "Oldest",
  },
];

export const sortingOptions2 = [
  {
    key: "NEWEST",
    label: "Newest",
  },
  {
    key: "OLDEST",
    label: "Oldest",
  },
  {
    key: "A-TO-Z",
    label: "A-to-Z",
  },
  {
    key: "Z-TO-A",
    label: "Z-to-A",
  },
];
/** End of TableHeaderComponent sorting options */

/** Inventory constants  kg, L, P  */

export const INVENTORY_INGREDIENT_UNIT = [
  {
    label: "KG",
    value: "kg",
  },
  {
    label: "Litre",
    value: "L",
  },
  {
    label: "Pieces",
    value: "P",
  },
];

export const INGREDIENT_UNITS = [
  {
    label: "KG",
    value: "kg",
  },
  {
    label: "Litre",
    value: "L",
  },
  {
    label: "Pieces",
    value: "P",
  },
  {
    label: "Gram",
    value: "g",
  },
  {
    label: "Milligram",
    value: "mg",
  },
  {
    label: "Milliliter",
    value: "mL",
  },
];

export const INVENTORY_STATUS = [
  {
    label: "Available",
    value: "Available",
  },
  {
    label: "Low Stock",
    value: "Low Stock",
  },
];

export const INVENTORY_WASTAGE_TYPE = [
  {
    label: "Ingredient",
    value: "INGREDIENT",
  },
  {
    label: "Food",
    value: "FOOD",
  },
  {
    label: "Add-Ons",
    value: "ADD_ONS",
  },
];

export const INVENTORY_WASTAGE_STATUS = [
  {
    label: "STATUS-A",
    value: "STATUS-A",
  },
  {
    label: "STATUS-B",
    value: "STATUS-B",
  },
];

export const INVENTORY_WASTAGE_REASON = [
  {
    label: "Spoilage",
    value: "Spoilage",
  },
  {
    label: "Expired",
    value: "Expired",
  },
  {
    label: "Miscalculation",
    value: "Miscalculation",
  },
];

export const INVENTORY_RECIPE_TYPE = [
  {
    label: "Food",
    value: "FOOD",
  },
  {
    label: "Add-Ons",
    value: "ADD_ONS",
  },
  {
    label: "Addition Item",
    value: "ADDITION_ITEM",
  },
];

export const INVENTORY_ADUSTMENT_TYPE_UNIT = [
  {
    label: "TK",
    value: "TK",
  },
  {
    label: "%",
    value: "PERCENT",
  },
];

export const INVENTORY_TYPES = [
  {
    label: "Item Wise",
    value: "ITEM",
  },
  {
    label: "Ingredient Wise",
    value: "INGREDIENT",
  },
];

export const INVOICE_NAME_AND_LOGO_SETTINGS = [
  {
    label: "Name",
    value: "NAME",
  },
  {
    label: "Logo",
    value: "LOGO",
  },
];

export const INVENTORY_VARIANT_TABS_BGCOLORS = ["#1BA09C", "#FCBD10"];

/** End Inventory contants */

/** Printer Settings */
export const CONNECTION_TYPES = [
  {
    label: "Wifi/LAN",
    value: "TCP",
  },
  {
    label: "USB",
    value: "USB",
  },
  {
    label: "Bluetooth",
    value: "Bluetooth",
  },
];

export const PRINTER_TYPES = [
  {
    label: "58mm",
    value: "58",
  },
  {
    label: "80mm",
    value: "80",
  },
  {
    label: "Others",
    value: "Others",
  },
];
/** End of printer settings */

export const ORDER_VIEW_TYPE = [
  {
    label: "Grid",
    value: "GRID",
  },
  {
    label: "List",
    value: "LIST",
  },
];

// For a number field these characters are valid but we are not allowing them.
export const cashFieldInvalidCharacters = [".", ",", "e", "+", "-"];
export const numberFieldInvalidCharacters = [",", "e", "+", "-"];
export const wholeNumberFieldAllowedCharacters = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

export const CharLimit = {
  Name: 100,
  Address: 200,
  Details: 2000,
};

export const PAGINATION_PAGE_OPTIONS = ["5", "10", "20", "30", "50", "100", "150", "200"];
export const DISCOUNT_TYPES = [
  {
    value: "1",
    label: constants.DISCOUNT_TYPE.AMOUNT,
  },
  {
    value: "2",
    label: constants.DISCOUNT_TYPE.PERCENTAGE,
  },
];

export const LOYALTY_DISCOUNT_TYPES = [
  { label: "Point Based", value: "POINT_BASED" },
  { label: "Spend Based", value: "SPEND_BASED" },
];

export const TAKEOUT_TYPES = ["foodpanda", "Pathao Food", "foodi", "DUOS EATS", "Foodfex"];

export const TABLE_AND_STAFF_LIST_CONTEXT = {
  WAITER_ASSIGN: "WAITER_ASSIGN",
  WAITER_LIST: "WAITER_LIST",
};

export const TABLE_STATUS_COLORS = {
  AVAILABLE: "#97D361",
  ON_DINE: "#FFACA1",
  OCCUPIED: "#FFD700",
  RESERVED: "#97F8EC",
};

export const TABLE_RESIZE_RATIO = {
  MIN: 0.8,
  MAX: 1.2,
};

export const SELECTED_TABLE_STATUS = {
  DRAFT: 'DRAFT',
  TEMP: 'TEMP',
  OLD: 'OLD'
};
